/**
 * Capacitor bridge for the optional iOS RoomPlan / LiDAR pilot.
 *
 * Native implementation lives in:
 *   frontend/ios/App/App/Plugins/RoomPlanPlugin.swift
 *
 * On web / Android / non-LiDAR iPhones this falls back to unavailable —
 * camera capture remains the universal path.
 */
import { registerPlugin } from '@capacitor/core';

const RoomPlanPlugin = registerPlugin('RoomPlan', {
  web: () => ({
    isAvailable: async () => ({ available: false, reason: 'web' }),
    scanRoom: async () => {
      throw new Error('RoomPlan is only available on LiDAR-capable iOS devices');
    },
  }),
});

export default RoomPlanPlugin;
